/* eslint-disable import/prefer-default-export */
import React from 'react';

export const EmptyStakingListImage = () => (
  <img src="./assets/images/no-deposit.png" alt="No List" />
);
